import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { SliderBase } from '@/components/ui/Slider/SliderBase';
import { getScreenValueOfNumber } from '@/utils/style/config';
// スライダー設定
const baseSetting = {
    arrows: true,
    infinite: false,
    responsive: [
        {
            breakpoint: getScreenValueOfNumber('md') - 1,
            settings: {
                arrows: false,
                slidesToShow: 1,
            },
        },
        {
            breakpoint: getScreenValueOfNumber('lg') - 1,
            settings: {
                arrows: false,
                slidesToShow: 2,
            },
        },
        {
            breakpoint: getScreenValueOfNumber('xl') - 1,
            settings: {
                slidesToShow: 2,
            },
        },
    ],
    slidesToScroll: 1,
    slidesToShow: 3,
    variableWidth: true,
};
export const customNextButtonProps = {
    customClassName: '!-right-56',
};
export const customPrevButtonProps = {
    customClassName: '!-left-56',
};
/**
 * TOP: 共通のスライダー
 * @description 内部のItemは、lg以上では必ず320pxを設定してください
 * @param props
 * @returns
 */
export const TopBaseSlider = (props) => {
    const { children, className = '', setting = baseSetting } = props;
    return (_jsx("div", Object.assign({ className: clsx('lg:px-[56px] mx-auto', className) }, { children: _jsx(SliderBase, Object.assign({ customNextButtonProps: customNextButtonProps, customPrevButtonProps: customPrevButtonProps, setting: setting }, { children: children })) })));
};
